<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        type="pagetop"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        setHeight="500px"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            dense
            :is="tab.component"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gas-leak-detection-alram-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      tab: 'gasLeakDetectionAlarmInfo',
      tabItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.tabItems = [
        // 기본정보 정보
        { name: 'gasLeakDetectionAlarmInfo', icon: 'info', label: 'LBL0010529', component: () => import(`${'./gasLeakDetectionAlarmInfo.vue'}`) }, // 가스누출감지 경보기 설치계획
        // 도면
        { name: 'gasLeakDetectionAlarmPid', icon: 'tab', label: 'LBL0010530', component: () => import(`${'./gasLeakDetectionAlarmPid.vue'}`) }, // 가스누출감지 경보기 설치계획도
        // 문서
        { name: 'gasLeakDetectionAlarmDoc', icon: 'assignment', label: 'LBL0010531', component: () => import(`${'./gasLeakDetectionAlarmDoc.vue'}`) } // 가스누출감지 경보기 설치계획 문서
      ]
    },

  }
};
</script>